// extracted by mini-css-extract-plugin
export var attachButton = "_jk-8";
export var sendButton = "_jk-2";
export var sendDisabled = "_jk-4";
export var sendEnabled = "_jk-3";
export var sendIcon = "_jk-6";
export var sendIconDisabled = "_jk-7";
export var sendStreaming = "_jk-5";
export var textarea = "_jk-1";
export var wrapper = "_jk-0";